/**
 * Pure helpers for reviewing a PRATUS AI automation rule draft in the real rule
 * editor. The editor's saved payload travels back to
 * `draft_org_event_automation_rule` as the `rule_payload` inline edit, which
 * the review queue folds into the resume decision's `edited_args`.
 */
import type { RuleDraftPayload } from 'components/MapPage/CorporateViewTabs/EventsTab/ruleFormModel';
import type { ItemState, PendingConfirmation } from './types';

export const DRAFT_AUTOMATION_RULE_TOOL = 'draft_org_event_automation_rule';
export const RULE_PAYLOAD_EDIT = 'rule_payload';

export function isAutomationRuleConfirmation(
  item: PendingConfirmation | undefined
): boolean {
  const rule = item?.preview?.rule;
  return (
    item?.tool_name === DRAFT_AUTOMATION_RULE_TOOL &&
    !!rule &&
    typeof rule === 'object'
  );
}

/** The reviewer's saved payload when present, else the AI draft. */
export function currentRulePayload(
  item: PendingConfirmation,
  edits: Record<string, unknown> | undefined
): RuleDraftPayload {
  const saved = edits?.[RULE_PAYLOAD_EDIT];
  if (saved && typeof saved === 'object') return saved as RuleDraftPayload;
  return item.preview?.rule as RuleDraftPayload;
}

/** Unit state after the reviewer saves from the editor. */
export function savedRuleState(
  current: ItemState | undefined,
  payload: RuleDraftPayload
): ItemState {
  return {
    ...current,
    respondText: undefined,
    verdict: 'accepted',
    edits: { ...current?.edits, [RULE_PAYLOAD_EDIT]: payload },
  };
}
